/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_RectificationInputs */

const en_privacy_section_7_rectification = /** @type {(inputs: Privacy_Section_7_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to rectification`)
};

const lv_privacy_section_7_rectification = /** @type {(inputs: Privacy_Section_7_RectificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiesības uz labošanu`)
};

/**
* | output |
* | --- |
* | "Right to rectification" |
*
* @param {Privacy_Section_7_RectificationInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_rectification = /** @type {((inputs?: Privacy_Section_7_RectificationInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_RectificationInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_rectification(inputs)
	return en_privacy_section_7_rectification(inputs)
});